
import Component, { mixins } from "vue-class-component"
import Calculator from "../mixins/Calculator.vue"
import BaseLogic from "@/logic/base_logic"
import FilialeHeader from "../custom/FilialeHeader.vue"
import ReservierungNeu from "@/entities/common/reservierung_neu"
import IdRequest from "@/entities/common/request/id_request"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import RemoteResult from "@/entities/common/remote_result"
import Formatter from "@/logic/formatter"
import router from "@/router"
import RouteNames from "@/util/route_names"
import ArtikelRow from "../custom/ArtikelRow.vue"
import ReservierungVorbestellungPending from "@/entities/common/reservierung_vorbestellung_pending"
import { response } from "express"

@Component({ components: { FilialeHeader, ArtikelRow } })
export default class ReservierungDetails extends mixins(Calculator) {
  logic: ReservierungDetailsLogic = null

  mounted() {
    this.logic = new ReservierungDetailsLogic()
    this.logic.init(this.$route.params.reservierungId)
  }

  gebeZeitraum() {
    return this.logic.gebeZeitraum()
  }

  vorbestellungBeginnen() {
    this.logic.vorbestellungBeginnen()
  }

  vorbestellungBearbeiten() {
    this.logic.vorbestellungBearbeiten()
  }
}

class ReservierungDetailsLogic extends BaseLogic {
  reservierung: ReservierungNeu

  init(reservierungId: string) {
    var request = new IdRequest()
    request.id = reservierungId

    Poster.postUser<RemoteResult<ReservierungNeu>>(
      RestPaths.reservierungenDetailsKunde,
      request
    ).then((response) => {
      if (response.data.success) {
        this.reservierung = response.data.payload
        this.mainLogic.reservierung = this.reservierung
      }
    })
  }

  vorbestellungBearbeiten() {
    var request = new IdRequest()
    request.id = this.reservierung.id

    Poster.postMember<RemoteResult<ReservierungVorbestellungPending>>(
      RestPaths.reservierungenVorbestellungBearbeiten,
      request
    ).then((response) => {
      this.mainLogic.reservierung.vorbestellungPending = response.data.payload
      router.push({
        name: RouteNames.RESERVIERUNG.VORBESTELLUNG_PRODUKTE,
      })
    })
    // router.push({
    //   name: RouteNames.RESERVIERUNG_VORBESTELLUNG.BEARBEITEN,
    //   params: { reservierungId: this.reservierung.id },
    // }),
  }

  gebeZeitraum() {
    return (
      Formatter.formatiereDatumUhrzeit(this.reservierung.zeitVon) +
      " - " +
      Formatter.formatiereDatumUhrzeit(this.reservierung.zeitBis)
    )
  }

  vorbestellungBeginnen() {
    var request = new IdRequest()
    request.id = this.reservierung.id

    Poster.postMember<RemoteResult<string>>(
      RestPaths.reservierungenVorbestellungPendingBeginnen,
      request
    ).then((response) => {
      if (response.data.success) {
        var pendingDto = new ReservierungVorbestellungPending()
        pendingDto.id = response.data.payload
        this.mainLogic.reservierung.vorbestellungPending = pendingDto

        router.push({
          name: RouteNames.RESERVIERUNG.VORBESTELLUNG_PRODUKTE,
          params: { reservierungId: this.reservierung.id },
        })
      }
    })
  }
}
